var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-common-btn tac",class:[_vm.size,{touch:_vm.touch},_vm.typeClass,{border: _vm.border},{disabled:_vm.disabled}],on:{"touchstart":_vm.touchstart,"click":_vm.handler,"touchend":_vm.touchend}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-b6e7223c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/v-common-btn.vue
// module id = 1175
// module chunks = 358